module.exports = __webpack_public_path__ + "static/media/logo-mini.8c6558b0.svg";